import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Appcost(props) {
    return (
        <div className="p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Marketing">
                            <h2>Quickly Move From Research To Marketing Phase With Our R&D Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>TekRevol’s expert teams with significant experience building digital products and offering services understand the dynamics of penetrating the digital domain. To develop your ideas and concepts with perfection, hire our R&D services today.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Appcost;
